export default function ChecklistTaskNote({ comment, language }) {
  if (!comment) return null;

  let text = "";
  if (typeof comment === "string") {
    text = comment.trim();
  } else if (typeof comment === "object") {
    text = String(
      (language && comment[language]) ||
        comment.default ||
        comment.en ||
        comment[`content_${language}`] ||
        ""
    ).trim();
  }
  if (!text) return null;

  return (
    <div style={{ padding: "8px 0 0" }}>
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          color: "#333",
          fontStyle: "normal",
          marginBottom: 2,
        }}
      >
        Notes/Comment
      </div>
      <div
        style={{
          fontSize: 16,
          color: "#666",
          fontStyle: "italic",
          lineHeight: 1.4,
        }}
      >
        {text}
      </div>
    </div>
  );
}
